import { type MenuItem, MenuItemType } from "types"

export const getMenuItemTypePath = (menuItem: MenuItem) =>
    menuItem.menuItemType === MenuItemType.TapSensor ? menuItem?.tapSensor?.tappedKeg : menuItem
